import { useCallback, useState } from "react";

export const useCaptureElement = <T = Element>() => {
  const [element, setElement] = useState<T>();
  const captureElement = useCallback((element?: null | T) => {
    if (!element) return;
    setElement(element);
  }, []);
  return { captureElement, element };
};
